import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../../components/Button';

export const StyledRecipientSection = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid ${colorsPalettes.carbon[100]};
  flex-shrink: 0;
`;

export const StyledSearchWrapper = styled.div`
  position: relative;

  > div {
    border-radius: 6px;
    border-color: ${colorsPalettes.carbon[100]};
    padding: 5px 8px;
    gap: 4px;

    .SWReactIcons {
      padding: 0;

      > span svg {
        width: 16px;
        height: 16px;
      }
    }

    input {
      height: auto;
      padding: 0;
    }
  }
`;

export const StyledRecipientChip = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border: 1px solid ${colorsPalettes.carbon[100]};
  border-radius: 6px;
  background: ${colorsPalettes.carbon[0]};
`;

export const StyledChipInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const StyledChipName = styled.span`
  ${setFontVariant('report', colorsPalettes.carbon[500])};
  line-height: 20px;
`;

export const StyledChipRole = styled.span`
  ${setFontVariant('listItem3', colorsPalettes.carbon[300])};
  line-height: 16px;
`;

export const StyledChipRemove = styled(Button)`
  width: 20px;
  height: 20px;
  padding: 0;
  background: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 6px;
    height: 6px;
  }

  &:hover,
  &:active {
    background: ${colorsPalettes.bluegrey[100]};
  }

  &:disabled {
    background: transparent;
    opacity: 0.4;
  }
`;

export const StyledDropdown = styled.div<{ isVisible: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 2px);
  background: ${colorsPalettes.carbon[0]};
  border: 1px solid ${colorsPalettes.carbon[100]};
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(9, 37, 64, 0.12);
  z-index: 10;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  max-height: 260px;
  overflow-y: auto;
`;

export const StyledDropdownHeader = styled.div`
  ${setFontVariant('listItem3', colorsPalettes.carbon[300])};
  padding: 10px 16px 6px;
`;

export const StyledDropdownItem = styled.div`
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.1s;

  &:hover {
    background: ${colorsPalettes.bluegrey[100]};
  }
`;

export const StyledDropdownName = styled.div`
  ${setFontVariant('report', colorsPalettes.carbon[500])};
  line-height: 20px;
`;

export const StyledDropdownRole = styled.div`
  ${setFontVariant('listItem3', colorsPalettes.carbon[300])};
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
